import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import Swal from "sweetalert2";
import Select from "react-select";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  ButtonGroup,
  Button,
  Image
} from "react-bootstrap";
import {
  ReviewedApplication,
  ApprovedApplication,
  RejectedApplication,
  getMedicalCert,
  getHRReviewPagination,
  searchHRReviewPagination,
  updateList,
  resetList,
  getSpecialLeaveAttachment,
  getLeaveApplicationDetails,
  editLeaveApplicationHR,
  updateCert,
  updateSpecialCert,
  updateLeaveApplicationDetails
} from "../../3.Store/ReviewLeaveApplicationSlice";
import { editLeaveApplication, getDaysApplying, editMedicalCertificate, editSpecialAttachment, addSpecialAttachment, addMedicalCertificate, deleteLeaveApplication, withdrawLeaveApplication } from "../../3.Store/ApplicationSlice";
import { LeaveType, LeaveNumberDay, Location, SpecialLeaveTypeOption } from "../../2.Commons/DropdownOption";
import { ThreeDots } from 'react-loader-spinner';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { openEditor } from "react-profile";
import PDFViewer from "../../2.Commons/PDFViewer";
import { reviewWithdrawal } from "../../3.Store/LeaveWithdrawalSlice";

const ReviewLeaveForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const details = useSelector(state => state.ReviewLeaveApplicationSlice.list);
  const cert = useSelector(state => state.ReviewLeaveApplicationSlice.cert);
  const loading = useSelector(state => state.ReviewLeaveApplicationSlice.loading);
  const special_attachment = useSelector(state => state.ReviewLeaveApplicationSlice.special_attachment);
  // const [loading, setLoading] = useState(false);
  const currentPage = useSelector(state => state.ReviewLeaveApplicationSlice.currentPage);
  const search = useSelector((state) => state.ReviewLeaveApplicationSlice.search);
  const { applying } = useSelector(
    (state) => state.ApplicationSlice
  );

  const [changeCert, setChangeCert] = useState(false);
  const [fullImage, setFullImage] = useState(null);
  const [loading2, setLoading2] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      if (id) {
        try {
          // if (search.searchText === "" && (
          //   search.advancedLeave ||
          //   search.annualLeave ||
          //   search.hospitalizationLeave ||
          //   search.maternityLeave ||
          //   search.otherLeave ||
          //   search.sickLeave ||
          //   search.specialLeave ||
          //   search.unpaidLeave
          // )) {
          //   const entity = { ...search };
          //   await dispatch(searchHRReviewPagination({ body: entity, currentPage }));
          // } else if (search.searchText !== "") {
          //   const entity = { ...search };
          //   await dispatch(searchHRReviewPagination({ body: entity, currentPage }));
          // } else {
          //   await dispatch(getHRReviewPagination({ currentPage }));
          // }

          await dispatch(getLeaveApplicationDetails({ id }));
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };
    fetchData();
  }, [id, search, currentPage]);

  useEffect(() => {
    const appendTime = (date, ampm) => {
      return ampm === "AM" ? `${date} 08:00:00` : `${date} 13:00:00`;
    };

    const handleMCase = async () => {
      try {
        const fromDateString = appendTime(moment(details?.from_date.date).format("YYYY-MM-DD"), details?.from_ampm);
        const toDateString = appendTime(moment(details?.to_date.date).format("YYYY-MM-DD"), details?.to_ampm);

        console.log(fromDateString);
        console.log(details?.leave_type.id);

        const entity = {
          ...applying,
          employee: { id: details.employee.id },
          from_datetime: fromDateString,
          leave_type: { id: details?.leave_type.id },
          to_datetime: toDateString
        };

        console.log(entity);
        // await dispatch(updateList(entity));

        // Await the dispatch call to get the updated days applying
        const updatedDaysApply = await dispatch(getDaysApplying(entity));
        console.log(updatedDaysApply);

        // Update the application with the correct number of days
        const days_applying = { ...details, number_of_days: updatedDaysApply.payload };
        await dispatch(updateList(days_applying));

      } catch (error) {
        console.error('Error updating days applying:', error);
      }
    };

    if (!details?.from_date || !details?.to_date) {
      return;
    }

    handleMCase();
  }, [
    details?.from_date?.date && moment(details?.from_date?.date).format("YYYY-MM-DD"),
    details?.to_date?.date && moment(details?.to_date?.date).format("YYYY-MM-DD"),
    details?.from_ampm,
    details?.to_ampm
  ]);

  useEffect(() => {
    // Function to fetch data based on leave type
    const fetchData = async () => {
      try {
        if (details.leave_type.id === "SI") {
          await dispatch(getMedicalCert({ id }));
        } else if (details?.leave_type?.id === "SP") {
          await dispatch(getSpecialLeaveAttachment({ id }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

  }, [details?.leave_type?.id]);

  const handleBtnReviewed = () => {

    if (details?.leave_type.id === "SI") {
      if (!cert.file) {
        Swal.fire({
          title: "Please upload medical certificate",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
    }

    if (details?.leave_type.id === "SP") {
      if (!special_attachment.file) {
        Swal.fire({
          title: "Please attach a proof document.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
    }

    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {

        let day_description;
        let numberofday_type;

        const fromDateFormatted = moment(details.from_date.date).format('YYYY-MM-DD');
        const toDateFormatted = moment(details.to_date.date).format('YYYY-MM-DD');
        const appliedDateFormatted = moment(details.created).format('YYYY-MM-DD');

        if (details.number_of_days !== "1.0" && details.number_of_days !== "0.5") {
          day_description = `${details.number_of_days} days leave applied on ${appliedDateFormatted}, from ${fromDateFormatted} ${details.from_ampm} to ${toDateFormatted} ${details.to_ampm}.`;
          numberofday_type = "M";
        } else if (details.number_of_days === "0.5") {
          day_description = `${details.number_of_days} day leave applied on ${appliedDateFormatted} for ${fromDateFormatted} ${details.from_ampm}.`;
          numberofday_type = "H";
        } else if (details.number_of_days === "1.0") {
          day_description = `${details.number_of_days} day leave applied on ${appliedDateFormatted} for ${fromDateFormatted}.`;
          numberofday_type = "1";
        }

        // const entity = {
        //   ...application,
        //   description: day_description,
        //   numberofday_type: { id: numberofday_type }
        // };

        const entity = { ...details, description: day_description, numberofday_type: { id: numberofday_type } };  // Clone details
        console.log(entity);
        const hr_remark = details?.hr_remark;  // Extract hr_remark

        console.log(entity);

        dispatch(editLeaveApplicationHR({ id, ...entity })).unwrap()
          .then(() => {

            dispatch(ReviewedApplication({ id, hr_remark })).unwrap();
            if (details?.leave_type.id === "SI") {
              if (cert.id) {
                dispatch(editMedicalCertificate({ ...cert, id: cert.id }));
              }
              else {
                const attach = { ...cert, leave_application: { id } };
                dispatch(addMedicalCertificate(attach));
              }
            }
            else if (details?.leave_type.id === "SP") {
              if (special_attachment.id) {
                dispatch(editSpecialAttachment({ ...special_attachment, id: special_attachment.id }));
              }
              else {
                const attach = { ...special_attachment, leave_application: { id } };
                dispatch(addSpecialAttachment(attach));
              }
            }

            Swal.fire("Leave Application Reviewed/Updated", "", "success", "OK").then(() => {
              dispatch(resetList());
              // navigate(-1);
              navigate("/ReviewLeaveList");
            });
          })
          .catch((err) => {
            Swal.fire("Error", err.response?.data || 'An error occurred', "error", "OK");
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Review cancelled', 'error');
      }
    });
  };

  const handleBtnWithdraw = () => {
    Swal.fire({
      title: 'Are you sure you want to withdraw this leave application?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (!result.isConfirmed) {
        Swal.fire('Cancelled', 'Withdrawal has been cancelled', 'info');
        return;
      }
  
      setLoading2(true);
  
      dispatch(withdrawLeaveApplication({ id, reason_withdrawal: 'Withdrawn by HR' }))
        .unwrap()
        .then((response) => {
          // ✅ get actual withdrawal ID from API response
          const entity = {
            id: response.id,   // <-- IMPORTANT
            remark_withdrawal: details?.hr_remark || "",
            status: { id: 200 }
          };
  
          return dispatch(reviewWithdrawal(entity)).unwrap();
        })
        .then(() => {
          Swal.fire({
            title: 'Leave Application Withdrawn',
            icon: 'success',
            confirmButtonText: 'OK'
          }).then(() => {
            dispatch(resetList());
            navigate('/ReviewLeaveList');
          });
        })
        .catch((err) => {
          Swal.fire(
            'Error',
            err?.response?.data?.message || 'An error occurred',
            'error'
          );
        })
        .finally(() => {
          setLoading2(false);
        });
    });
  };

  const handleBtnDelete = () => { 
    Swal.fire({ 
      title: 'Are you sure you want to delete this leave application?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading2(true);
        dispatch(deleteLeaveApplication({ id }))
          .unwrap()
          .then(() => { 
            setLoading2(false);
            Swal.fire("Leave Application Deleted", "", "success", "OK").then(() => {
              dispatch(resetList());
              navigate(`/ReviewLeaveList`);
            })
          })
          .catch((err) => {
            setLoading2(false);
            Swal.fire("Error", err.response?.data || 'An error occurred', "error", "OK");
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Deletion has been cancelled',
          'error'
        );
      }
    });
  };

  const handleBtnBack = () => {
    dispatch(resetList());
    // navigate(-1);
    navigate("/ReviewLeaveList");
  };

  const handleBtnReject = () => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading2(true);
        const entity = { ...details };

        dispatch(editLeaveApplication({ id, ...entity }))
          .unwrap()
          .then(() => {
            return dispatch(RejectedApplication({ id, hr_remark: details?.hr_remark })).unwrap();
          })
          .then(() => {
            setLoading2(false);
            Swal.fire("Leave Application Rejected", "", "success", "OK").then(() => {
              dispatch(resetList());
              navigate(`/ReviewLeaveList`);
            })
          })
          .catch((err) => {
            setLoading2(false);
            Swal.fire("Error", err.response?.data || 'An error occurred', "error", "OK");
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Rejection has been cancelled',
          'error'
        );
      }
    });
  };

  const handleBtnApprove = () => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading2(true);
        const entity = { ...details };

        dispatch(editLeaveApplication({ id, ...entity }))
          .unwrap()
          .then(() => {
            return dispatch(ApprovedApplication({ id, hr_remark: details?.hr_remark })).unwrap();
          })
          .then(() => {
            setLoading2(false);
            Swal.fire("Leave Application Approved", "", "success", "OK").then(() => {
              dispatch(resetList());
              navigate(`/ReviewLeaveList`);
            })
          })
          .catch((err) => {
            setLoading2(false);
            Swal.fire("Error", err.response?.data || 'An error occurred', "error", "OK");
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Approval has been cancelled',
          'error'
        );
      }
    });
  };

  const handleRemarkChange = (e) => {
    // const entity = { ...details, hr_remark: e.target.value };
    // console.log(entity);
    // dispatch(updateList(entity));

    const text = e.target.value;
          
    // Detect NON-English characters (anything outside ASCII)
    const isNonEnglish = /[^\u0000-\u007F]/.test(text);
  
    if (isNonEnglish) {
      Swal.fire({
        text: "Only English is allowed. / Hanya Bahasa Inggeris dibenarkan.",
        icon: "warning",
        confirmButtonText: "OK",
      });
  
      // DO NOT update — keep previous correct value
      const entity = { ...details };
      console.log(entity);
      dispatch(updateList(entity));
  
      return; // stop further processing
    }
  
    // Normal valid update
    const entity = { ...details, hr_remark: text };
    console.log(entity);
    dispatch(updateList(entity));
  };

  const handleChangeDropdownLeaveType = (value) => {
    console.log(value);
    const entity = {
      ...details,
      leave_type: {
        id: value.id,
      },
    };
    dispatch(updateList(entity));
    console.log(entity);
  };

  const handleChangeDropdownSpecialLeaveType = (value) => {
    console.log(value);
    const entity = {
      ...details,
      special_leave_type: {
        id: value.id,
      },
    };
    console.log(entity);
    dispatch(updateList(entity));
  };

  const handleChangeDropdownLocation = (value) => {
    console.log(value);
    const entity = {
      ...details,
      location_type: {
        id: value.id,
      },
    };
    dispatch(updateList(entity));
    console.log(entity);
  };

  const handleCheckForm = (e) => {
    const entity = { ...details, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateList(entity));
  };

  const handleChangeFromDate = (e) => {
    const entity = { ...details, from_date: { date: e.target.value } };
    console.log(entity);
    dispatch(updateList(entity));
  };

  const handleChangeToDate = (e) => {
    const entity = { ...details, to_date: { date: e.target.value } };
    console.log(entity);
    dispatch(updateList(entity));
  };

  const handleSPAttachmentChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;
  
    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
  
    if (!allowedTypes.includes(selectedFile.type)) {
      Swal.fire({
        text: "Only JPG, PNG, or PDF files are allowed. / Hanya fail JPG, PNG atau PDF dibenarkan.",
        icon: "warning",
        confirmButtonText: "OK"
      });
  
      event.target.value = null;
  
      const entity = {
        ...special_attachment,
        file: "",
        filename: "",
        filetype: "",
        filesize: ""
      };
      dispatch(updateSpecialCert(entity));
      return;
    }
  
    setLoading2(true); // Use a separate loading state if needed
  
    const reader = new FileReader();
  
    reader.onloadend = () => {
      const fileResult = reader.result;
  
      if (selectedFile.type === 'application/pdf') {
        const base64String = fileResult.split(',')[1];
        finishUpload(base64String);
      } else {
        setFullImage(fileResult);
        setLoading2(false); // Allow user to edit first before setting true again in finish
  
        openEditor({ src: selectedFile })
          .then(editor => {
            const base64String = editor?.editedImage?.getDataURL();
            if (!base64String) {
              setLoading2(false); // User cancelled editing
              return;
            }
            finishUpload(base64String);
          })
          .catch(error => {
            console.error("Editor error:", error);
            Swal.fire({
              text: "There was an error editing the image.",
              icon: "error",
              confirmButtonText: "OK"
            });
            setLoading2(false);
          });
      }
    };
  
    reader.onerror = () => {
      Swal.fire({
        text: "Error reading file.",
        icon: "error",
        confirmButtonText: "OK"
      });
      setLoading2(false);
    };
  
    reader.readAsDataURL(selectedFile);
  
    function finishUpload(base64String) {
      const entity = {
        ...special_attachment,
        file: base64String,
        filename: selectedFile.name,
        filetype: selectedFile.type,
        filesize: selectedFile.size
      };
  
      dispatch(updateSpecialCert(entity));
      console.log("Base64 File:", base64String);
  
      // Simulate final progress before turning off loader
      setTimeout(() => {
        setTimeout(() => {
          setLoading2(false);
        }, 500);
      }, 500);
    }
  };

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // const handleAttachmentChange = (event) => {
  //   console.log(516, Date.now());
  //   const selectedFile = event.target.files[0];
  //   if (selectedFile) {
  //     // Check file type
  //     setLoading2(true);
  //     const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

  //     if (!allowedTypes.includes(selectedFile.type)) {
  //       Swal.fire({
  //         text: "Only JPG, PNG, or PDF files are allowed. / Hanya fail JPG, PNG atau PDF dibenarkan.",
  //         icon: "warning",
  //         confirmButtonText: "OK"
  //       });

  //       // Clear the file input
  //       event.target.value = null;

  //       const entity = {
  //         ...cert,
  //         file: "",
  //         filename: "",
  //         filetype: "",
  //         filesize: ""
  //       };
  //       console.log(entity);
  //       dispatch(updateCert(entity));

  //       return;
  //     };

  //     const reader = new FileReader();

  //     reader.onloadend = async () => {
  //       const fileResult = reader.result;
  //       let base64String;

  //       if (selectedFile.type === 'application/pdf') {
  //         // For PDF files, strip off the data URL prefix
  //         base64String = fileResult.split(',')[1];
  //       } else {
  //         // For images or other file types, use the full data URL
  //         setFullImage(fileResult);
  //         const editor = await openEditor({ src: selectedFile });
  //         base64String = editor?.editedImage?.getDataURL();
  //       }

  //       await sleep(3000);

  //       const entity = {
  //         ...cert,
  //         file: base64String,
  //         filename: selectedFile.name,
  //         filetype: selectedFile.type,
  //         filesize: selectedFile.size
  //       };
  //       console.log(entity);
  //       dispatch(updateCert(entity));

  //       // Log file details
  //       console.log("Base64 File:", base64String);
  //       console.log("Filename:", selectedFile.name);
  //       console.log("Filetype:", selectedFile.type);
  //       console.log("Filesize:", selectedFile.size, "bytes");

  //       setLoading2(false);
  //     };
  //     console.log(582, Date.now());
  //     // Read the file as a data URL
  //     reader.readAsDataURL(selectedFile);
  //   }
  // };

  const handleAttachmentChange = (event) => {
    const selectedFile = event.target.files[0];

    if (!selectedFile) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

    if (!allowedTypes.includes(selectedFile.type)) {
      Swal.fire({
        text: "Only JPG, PNG, or PDF files are allowed. / Hanya fail JPG, PNG atau PDF dibenarkan.",
        icon: "warning",
        confirmButtonText: "OK"
      });

      event.target.value = null;

      const entity = {
        ...cert,
        file: "",
        filename: "",
        filetype: "",
        filesize: ""
      };
      dispatch(updateCert(entity));
      return;
    }

    setLoading2(true);

    const reader = new FileReader();

    reader.onloadend = () => {
      const fileResult = reader.result;

      if (selectedFile.type === 'application/pdf') {
        const base64String = fileResult.split(',')[1];

        finishUpload(base64String);
      } else {
        setFullImage(fileResult);
        setLoading2(false); 
        openEditor({ src: selectedFile })
          .then(editor => {          
            const base64String = editor?.editedImage?.getDataURL();
            if (!base64String) {
              // User likely cancelled, so don't show error — just reset loading and do nothing
              setLoading2(false);
              return;
            }
            finishUpload(base64String);
          })
          .catch(error => {
            console.error("Editor error:", error);
            Swal.fire({
              text: "There was an error editing the image.",
              icon: "error",
              confirmButtonText: "OK"
            });
            setLoading2(false);
          });
      }
    };

    reader.onerror = () => {
      Swal.fire({
        text: "Error reading file.",
        icon: "error",
        confirmButtonText: "OK"
      });
      setLoading2(false);
    };

    reader.readAsDataURL(selectedFile);

    function finishUpload(base64String) {
      const entity = {
        ...cert,
        file: base64String,
        filename: selectedFile.name,
        filetype: selectedFile.type,
        filesize: selectedFile.size
      };

      dispatch(updateCert(entity));
      console.log("Base64 File:", base64String);

      // Simulate final progress
      setTimeout(() => {
        setTimeout(() => {
          setLoading2(false);
        }, 500);
      }, 500);
    }
  };

  const handleEditImage = async () => {
    if (fullImage) {
      try {
        const editor = await openEditor({ src: fullImage });

        if (editor && editor.editedImage) {
          const updatedImage = editor.editedImage.getDataURL();
          const entity = { ...cert, file: updatedImage };
          dispatch(updateCert(entity));
        } else {
          console.error("Edited image not found.");
        }
      } catch (error) {
        console.error("Error opening editor:", error);
      }
    } else {
      console.error("Full image is not set.");
    }
  };

  console.log('loading:', loading, 'loading2:', loading2);

  return (
    <Container className="ContainerContent">
      {(loading || loading2) && (
        <ThreeDots
          visible={true}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
        <h1 className="TitleHeader">HR Review Leave Application</h1>
        <h1 className="MiniTitleHeader">View</h1>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">Staff Name</Form.Label>
          </Col>
          <Col md={6} sm={6}>
            <Form.Control value={details?.employee?.fullname} readOnly disabled/>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fw-normal fs-5">Leave Type</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            <Select
              name="leave_type"
              options={LeaveType}
              value={LeaveType.find(
                (option) => option.id === details?.leave_type?.id
              )}
              onChange={handleChangeDropdownLeaveType}

              /* 👇 ADD THESE - avoid covered by the PDF viewer */
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />
          </Col>
        </Row>

        {details?.leave_type?.id === "SI" && (
          // {changeCert && (
          <Row className="my-2">
            <Col md={8} sm={8}>
              <Form.Label className="FormLabel fw-normal fs-5">Change Medical Certificate</Form.Label>
            </Col>
            <Col md={4} sm={4}>
              {/* <Form.Control type="file" onChange={handleAttachmentChange}/> */}
              <Form.Control type="file" onChange={handleAttachmentChange} />
            </Col>
          </Row>
        )}

        {details?.leave_type?.id === "SI" && cert && cert.file && (
          <Row className="my-3">
            <Col md={12} sm={12} className="d-flex justify-content-center align-items-center">
              {/* Display image */}
              {cert.filetype.startsWith('image/') ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '10px',
                    backgroundColor: '#373c40',
                    height: '500px',
                    width: "100%",
                    overflow: 'auto',
                  }}
                >
                  <Image 
                    src={
                      cert.file.startsWith("data:")
                        ? cert.file
                        : `data:${cert.filetype};base64,${cert.file}`
                    }
                    alt="Uploaded file" 
                    fluid 
                    style={{ cursor: 'pointer',
                      maxWidth: '100%',
                      height: '100%',
                     }} 
                    onClick={handleEditImage}
                  />
                </div>
              ) : (
                // Display PDF
                // <iframe
                //   src={`data:${cert.filetype};base64,${cert.file}`}
                //   title="PDF file"
                //   width="100%"
                //   height="500px"
                // ></iframe>
                cert.file ? (
                  <div style={{ width: "100%" }}>
                    <PDFViewer base64Data={cert.file} height="500px" width="100%" />
                  </div>
                ) : (
                  <a href={`data:application/pdf;base64,${cert.file}`} download="attachment.pdf">
                    Download PDF
                  </a>
                )
              )}
            </Col>
          </Row>
        )}

        {/* Special Leave */}
        {details?.leave_type?.id == "SP" && (
          <>
            <Row className="my-2">
              <Col md={8} sm={8}>
                <Form.Label className="FormLabel fw-normal fs-5">
                  Special Leave Type
                </Form.Label>
              </Col>
              <Col md={4} sm={4}>
                <Select
                  name="special_leave_type"
                  options={SpecialLeaveTypeOption}
                  value={SpecialLeaveTypeOption.find(
                    (option) => option.id === details?.special_leave_type?.id
                  )}
                  onChange={handleChangeDropdownSpecialLeaveType}

                  /* 👇 ADD THESE - avoid covered by the PDF viewer */
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
              </Col>
            </Row>
          </>
        )}

        {details?.leave_type?.id === "SP" && (
          // {changeCert && (
          <Row className="my-2">
            <Col md={8} sm={8}>
              <Form.Label className="FormLabel fw-normal fs-5">Change Attachment</Form.Label>
            </Col>
            <Col md={4} sm={4}>
              {/* <Form.Control type="file" onChange={handleAttachmentChange}/> */}
              <Form.Control type="file" onChange={handleSPAttachmentChange} />
            </Col>
          </Row>
        )}

        {details?.leave_type?.id === "SP" && special_attachment && special_attachment.file && (
          <Row className="my-3">
            <Col md={12} sm={12} className="d-flex justify-content-center align-items-center">
              {/* Display image */}
              {special_attachment.filetype.startsWith('image/') ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '10px',
                    backgroundColor: '#373c40',
                    height: '500px',
                    width: "100%",
                    overflow: 'auto',
                  }}
                >
                  <Image 
                    src={
                      special_attachment.file.startsWith("data:")
                        ? special_attachment.file
                        : `data:${special_attachment.filetype};base64,${special_attachment.file}`
                    }
                    style={{ cursor: 'pointer',
                      maxWidth: '100%',
                      height: '100%',
                    }} 
                    alt="Uploaded file" 
                    fluid 
                  />
                </div>
              ) : (
                // Display PDF
                special_attachment.file ? (
                  <div style={{ width: "100%" }}>
                    <PDFViewer base64Data={special_attachment.file} height="500px" width="100%" />
                  </div>
                ) : (
                  <a href={`data:application/pdf;base64,${special_attachment.file}`} download="attachment.pdf">
                    Download PDF
                  </a>
                )
                // <iframe
                //   src={`data:${special_attachment.filetype};base64,${special_attachment.file}`}
                //   title="PDF file"
                //   width="100%"
                //   height="500px"
                // ></iframe>
              )}
            </Col>
          </Row>
        )}

        <Row className="my-2">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">From</Form.Label>
          </Col>
          <Col md={2} sm={6}>
            <Form.Check
              type="radio"
              label="AM"
              name="from_ampm"
              value="AM"
              checked={details?.from_ampm == "AM"}
              style={{ color: "#fff" }}
              onChange={handleCheckForm}
            />
            <Form.Check
              type="radio"
              label="PM"
              value="PM"
              name="from_ampm"
              checked={details?.from_ampm == "PM"}
              style={{ color: "#fff" }}
              onChange={handleCheckForm}
            />
          </Col>
          <Col md={4} sm={4}>
            {/* <Form.Control 
              type="date" 
              value={moment(details?.from_date?.date).format("YYYY-MM-DD")} 
              onChange={handleChangeFromDate}
              // min={maxFromDate}
              // max={maxToDate}
            /> */}
            <DatePicker
              selected={details?.from_date?.date ? new Date(details?.from_date?.date) : null}
              onChange={(date) =>
                handleChangeFromDate({
                  target: {
                    // name: "date",
                    value: moment(date).format("YYYY-MM-DD"),
                  },
                })
              }
              dateFormat="yyyy-MM-dd"
              className="form-control w-100 datepicker-icon"
            />
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">To</Form.Label>
          </Col>
          <Col md={2} sm={6}>
            <Form.Check
              type="radio"
              label="AM"
              checked={details?.to_ampm == "AM"}
              style={{ color: "#fff" }}
              name="to_ampm"
              value="AM"
              onChange={handleCheckForm}
            />
            <Form.Check
              type="radio"
              label="PM"
              checked={details?.to_ampm == "PM"}
              style={{ color: "#fff" }}
              name="to_ampm"
              value="PM"
              onChange={handleCheckForm}
            />
          </Col>
          <Col md={4} sm={4}>
            {/* <Form.Control 
              type="date" 
              value={moment(details?.to_date?.date).format("YYYY-MM-DD")} 
              onChange={handleChangeToDate}
              // min={maxFromDate}
              // max={maxToDate}
            /> */}
            <DatePicker
              selected={details?.to_date?.date ? new Date(details?.to_date?.date) : null}
              onChange={(date) =>
                handleChangeToDate({
                  target: {
                    // name: "date",
                    value: moment(date).format("YYYY-MM-DD"),
                  },
                })
              }
              dateFormat="yyyy-MM-dd"
              className="form-control w-100 datepicker-icon"
            />
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fw-normal fs-5">No. Days Applying</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            <Form.Control value={details?.number_of_days} readOnly disabled />
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fw-normal fs-5">Location</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            <Select
              options={Location}
              value={Location.find(
                (option) => option.id === details?.location_type?.id
              )}
              onChange={handleChangeDropdownLocation}
            />
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={12} sm={12}>
            <Form.Label className="FormLabel fw-normal fs-5">Reason</Form.Label>
            <Form.Control as="textarea" value={details?.reason_for_application} readOnly disabled/>
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={12} sm={12}>
            <Form.Label className="FormLabel fw-normal fs-5">Description</Form.Label>
            <Form.Control as="textarea" value={details?.description} readOnly disabled/>
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={12} sm={12}>
            <Form.Label className="FormLabel fw-normal fs-5">HR Remark</Form.Label>
            <Form.Control as="textarea" value={details?.hr_remark} onChange={handleRemarkChange} />
          </Col>
        </Row>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>

          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnReviewed}>
              Review/Update
            </Button>
            &nbsp; &nbsp;
            {details?.status?.id !== 100 && (
              <>
                <Button className="Button" onClick={handleBtnWithdraw}>
                  Withdraw
                </Button>
                &nbsp; &nbsp;
              </>
            )}
            {details?.status?.id == 100 && (
              <>
                <Button className="Button" onClick={handleBtnDelete}>
                  Delete
                </Button>
                &nbsp; &nbsp;
              </>
            )}
            <Button className="Button" onClick={handleBtnReject}>
              Reject
            </Button>
            &nbsp; &nbsp;
            <Button className="Button" onClick={handleBtnApprove}>
              Approve
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};
export default ReviewLeaveForm;